import { render, staticRenderFns } from "./Base600Orange.vue?vue&type=template&id=6d58c472&scoped=true&"
var script = {}
import style0 from "./Base600Orange.vue?vue&type=style&index=0&id=6d58c472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d58c472",
  null
  
)

export default component.exports